import MotifModalBody from '@ey/motif-react-wrapper/ModalBody';
import styled from 'styled-components';

export default styled.div`
	--gap: 2.4rem;
	grid-template-columns: 1fr 1fr;
	display: grid;
	gap: var(--gap);
	justify-content: center;
	.max-half {
		max-width: 50%;
	}

	.flex-1 {
		flex: 1;
	}

	.customColumns {
		padding-right: 0.3rem;
	}

	.flex-1-inline-horizontal {
		flex-direction: row;
		flex: 1;
		display: inline-flex;
		.prop-value {
			margin-right: 0.75rem;
		}
	}
	.motif-chip .motif-chip-button {
		background-color: transparent;
	}
	.modal-section {
		grid-column-start: 1;
		grid-column-end: 3;
		justify-content: space-around;
		&.contact-data {
			text-align: center;
			display: grid;
			border-bottom: 1px solid var(--modal-header-border-color);
			gap: 1rem;
			.chips {
				display: grid;
				justify-content: space-around;
			}
			.icon-text {
				display: inline-flex;
				gap: 0.5rem;
				align-items: center;
			}
			.contact-info {
				padding-right: 1rem;
				svg {
					width: 1.4rem !important;
				}
				&.phone {
					svg {
						cursor: default;
					}
				}
			}
		}
		.chip-group {
			display: flex;
			flex-wrap: wrap;
			.motif-chip {
				padding-right: 1rem;
				padding-bottom: 1rem;
			}
		}

		.prop-group {
			display: flex;
			flex-direction: column;
			padding-top: 1rem;
			gap: 0.75rem;
			&.group-access {
				.prop-name span {
					color: ${(props) => props.theme.color[`grey400`]};
				}
			}

			.prop-value {
				color: ${(props) => props.theme.color[`grey400`]};
				max-width: 40%;
				svg {
					margin: 2px;
				}
			}
		}

		&.left {
			grid-column-end: 2;
		}
		&.right {
			grid-column-start: 2;
		}
		&.left,
		&.right {
			.chip-group {
				padding-top: 1rem;
			}
			.motif-chip {
				padding-right: 1rem;
				padding-bottom: 1rem;
			}
		}

		&.section-custom-attributes {
			grid-column-start: 2;
			grid-row-start: 2;
			grid-row-end: 4;

			.chip-group {
				margin-bottom: 1rem;
			}
		}
	}
`;
